export const environment = {
    appVersion: require('../../../../package.json').version,
    baseUrl: '',
    production: true
};
